var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#indicator_10_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 2H1v28h20V2Z",
  stroke: "#7465EB",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5 14h7a.5.5 0 0 0 .41-.787l-3.5-5a.52.52 0 0 0-.82 0l-3.5 5a.5.5 0 0 0 .41.787ZM31.5 18h-7a.5.5 0 0 0-.41.787l3.5 5a.501.501 0 0 0 .82 0l3.5-5A.5.5 0 0 0 31.5 18Z",
  fill: "#7465EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 2v28",
  stroke: "#7465EB",
  strokeWidth: 2,
  strokeMiterlimit: 10
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "indicator_10_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgIndicator10;